"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _ReactStaticPage = require("../../../../../react-static/page/ReactStaticPage");

var _StopwatchStore = require("../../../timing/stores/StopwatchStore");

var _Stopwatch = require("../../../timing/components/Stopwatch");

var _StopwatchInstructions = require("../../../timing/components/StopwatchInstructions");

var _TimingBreadcrumb = require("../TimingBreadcrumb");

var _mobxReact = require("mobx-react");

var _class;

var StopwatchPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(StopwatchPage, _Component);

  function StopwatchPage() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = StopwatchPage.prototype;

  _proto.render = function render() {
    var title = "Stopwatch";
    var stopwatchStore = new _StopwatchStore.StopwatchStore();
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement(_TimingBreadcrumb.TimingBreadcrumb, null), _react.default.createElement("p", null, "An online stopwatch built with HTML and JavaScript. No Flash plugin required. Works on mobile phones, notebooks, desktop PCs, Macs etc. Load the stopwatch in your web browser or install it on your phone for offline use without using an App Store (coming soon)."), _react.default.createElement(_Stopwatch.Stopwatch, {
      stopwatchStore: stopwatchStore
    }), _react.default.createElement(_StopwatchInstructions.StopwatchInstructions, null));
  };

  return StopwatchPage;
}(_react.Component)) || _class;

exports.default = StopwatchPage;